import {UseFormReturn} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {Grid, Typography} from "@mui/material";
import {Frame} from "../base/Frame";
import {LabeledInput} from "../base/LabeledInput";
import {UserGlobalRole} from "../../types/domain/user";
import {SelectInput} from "../base/SelectInput";
import {USER_GLOBAL_ROLES} from "../../utils/enumItemsUtils";

export interface UserAccountFormInputs {
    globalRole: UserGlobalRole;
}

export interface Props {
    initFormValues: UserAccountFormInputs;
    form: UseFormReturn<UserAccountFormInputs>;
}

export const UserAccountForm: React.FC<Props> = ({initFormValues, form: {control}}) => {
    const {t} = useTranslation();

    return (
        <Frame>
            <Typography fontSize={16} textTransform="uppercase" sx={{mb: "1rem"}}>
                {t("users.account_form.account")}
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <LabeledInput label={t("users.account_form.role")}>
                        <SelectInput
                            name="globalRole"
                            control={control}
                            options={USER_GLOBAL_ROLES}
                            initialValue={initFormValues.globalRole}
                            getOptionLabel={(option) => option.label}
                        />
                    </LabeledInput>
                </Grid>
            </Grid>
        </Frame>
    );
};
